module.exports = __webpack_public_path__ + "img/icon07.64fc8a24.png";